import React, { Component } from 'react'
import styled from 'styled-components'
import { PDFReader } from 'react-read-pdf'

class PDFReport extends Component {
  state = {
    totalPage: null,
    pageNumber: 1,
  }

  onDocumentLoad = ({ totalPage }) => {
    this.setState({ totalPage })
  }

  render() {
    const { file } = this.props
    const { pageNumber, totalPage } = this.state
    return (
      <Div>
        <a href={file} target="_blank" rel="noopener noreferrer">
          <Container>
            <div style={{ overflow: 'scroll' }}>
              <PDFReader
                page={pageNumber}
                onDocumentComplete={this.onDocumentLoad}
                url={file}
              />
            </div>
            <HoverLink>
              <HoverSpan>click to view the full PDF</HoverSpan>
            </HoverLink>
          </Container>
        </a>

        <div>
          Previewing: page {pageNumber}
          {/* of {totalPage} */}
          &nbsp;&nbsp;
          {pageNumber > 1 && (
            <span>
              {/* eslint-disable-next-line */}
              <a
                onClick={e =>
                  e.preventDefault() ||
                  this.setState.bind(this)({
                    pageNumber: pageNumber - 1,
                  })
                }
                href="#"
              >
                prev
              </a>
              |&nbsp;
            </span>
          )}
          {pageNumber && (
            <span>
              {/* eslint-disable-next-line */}
              <a
                onClick={e =>
                  e.preventDefault() ||
                  this.setState.bind(this)({
                    pageNumber: pageNumber + 1,
                  })
                }
                href="#"
              >
                next
              </a>
            </span>
          )}
        </div>
      </Div>
    )
  }
}

const Div = styled.div`
  .ReactPDF__Page__canvas {
    margin: 0 auto;
  }
`
const Container = styled.div`
  position: relative;
  min-width: 100%;
`
const HoverLink = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: auto;
  opacity: 0;
  transition: 0.5s ease;
  background-color: RGBA(0, 0, 0, 0.5);
  &:hover {
    opacity: 1;
  }
`
const HoverSpan = styled.span`
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
`

export default PDFReport
